
    <div class="dialog-container">
      <mat-icon class="warning-icon">warning</mat-icon>
      
      <h2 mat-dialog-title>Confirmación</h2>
      
      <mat-dialog-content>
        <p>{{data.message}}</p>
      </mat-dialog-content>
      
      <mat-dialog-actions>
        <button mat-stroked-button class="btn-cancel" (click)="onNoClick()">
          No
        </button>
        <button mat-flat-button color="warn" [mat-dialog-close]="true">
          Sí
        </button>
      </mat-dialog-actions>
    </div>
  